import script from "./OidoAddressInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoAddressInput.vue?vue&type=script&setup=true&lang=js"

import "./OidoAddressInput.vue?vue&type=style&index=0&id=43b84244&scoped=true&lang=css"
import "./OidoAddressInput.vue?vue&type=style&index=1&id=43b84244&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b84244"]])

export default __exports__